// src/utils/dateUtils.js

const monthNames = [
  "Jan","Feb","Mar","Apr","May","Jun",
  "Jul","Aug","Sep","Oct","Nov","Dec"
];

export function formatDateTime(rawDate) {
  if (!rawDate) return "";

  const d = new Date(
    rawDate.endsWith("Z") ? rawDate : `${rawDate}Z`
  );

  return d.toLocaleString(undefined, {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
}

export function getRelativeTime(rawDate) {
  const d    = new Date(rawDate);
  const now  = new Date();
  const diff = now - d;
  const secs = Math.floor(diff / 1000);
  const mins = Math.floor(secs / 60);
  const hrs  = Math.floor(mins / 60);

  if (hrs < 24) {
    if (secs < 60) return `${secs} secs ago`;
    if (mins < 60) return `${mins} mins ago`;
    return `${hrs} hours ago`;
  }
  return null;
}

export function formatSmartDate(rawDate) {
  return formatDateTime(rawDate);
}